import { render, staticRenderFns } from "./manipulation.vue?vue&type=template&id=3dfbebe2&"
import script from "./manipulation.vue?vue&type=script&lang=js&"
export * from "./manipulation.vue?vue&type=script&lang=js&"
import style0 from "./manipulation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports